import { ScreenNames } from './screenMapping';
import type { DescopeFormData } from './types/descope';

const LINKTREE_BASE_URL =
  import.meta.env.VITE_LINKTREE_BASE_URL || 'https://linktr.ee';
const SIGNUP_REDIRECT_PATH = '/register/get-started';

const ARKOSE_LOGIN_GATE_INTERACTION_ID = 'arkose-login-continue';
const ARKOSE_SIGNUP_GATE_INTERACTION_ID = 'arkose-signup-continue';
const ARKOSE_SMS_LOGIN_GATE_INTERACTION_ID = 'arkose-sms-login-continue';
const ARKOSE_SMS_SIGNUP_GATE_INTERACTION_ID = 'arkose-sms-signup-continue';

export type ArkoseGateConfig = {
  authFlow: 'login' | 'signup';
  interactionId: string;
  backHref: string;
  form: DescopeFormData;
};

export const getArkoseGateConfig = (
  screenName: string | undefined,
  arkoseGateForm: DescopeFormData,
  smsAuthForm: DescopeFormData
): ArkoseGateConfig | undefined => {
  const gateConfig = {
    [ScreenNames.ARKOSE_LOGIN_GATE]: {
      authFlow: 'login',
      interactionId: ARKOSE_LOGIN_GATE_INTERACTION_ID,
      backHref: `${LINKTREE_BASE_URL}/login`,
      form: arkoseGateForm,
    },
    [ScreenNames.ARKOSE_SIGNUP_GATE]: {
      authFlow: 'signup',
      interactionId: ARKOSE_SIGNUP_GATE_INTERACTION_ID,
      backHref: `${LINKTREE_BASE_URL}${SIGNUP_REDIRECT_PATH}`,
      form: arkoseGateForm,
    },
    [ScreenNames.ARKOSE_SMS_LOGIN_GATE]: {
      authFlow: 'login',
      interactionId: ARKOSE_SMS_LOGIN_GATE_INTERACTION_ID,
      backHref: `${LINKTREE_BASE_URL}/login`,
      form: smsAuthForm,
    },
    [ScreenNames.ARKOSE_SMS_SIGNUP_GATE]: {
      authFlow: 'signup',
      interactionId: ARKOSE_SMS_SIGNUP_GATE_INTERACTION_ID,
      backHref: `${LINKTREE_BASE_URL}${SIGNUP_REDIRECT_PATH}`,
      form: arkoseGateForm,
    },
  } as const;
  return screenName
    ? gateConfig[screenName as keyof typeof gateConfig]
    : undefined;
};
